import {keepPreviousData, useQuery} from '@tanstack/react-query'
import {publicScheduleKeys} from '../lib/queryKeys'
import {getPublicPartnerEventsStrict, type PublicScheduleEvent} from '../services/public-schedule.service'
import type {LocalWeekRange} from '../components/client/public-entry/publicEntryDates'

/** Loads further weeks in the browser; the server-rendered week seeds the cache. */
export function usePublicWeekSchedule(
    partnerSlug: string,
    weekRange: LocalWeekRange,
    initial: {weekStart: string; events: PublicScheduleEvent[]},
) {
    return useQuery({
        queryKey: publicScheduleKeys.week(partnerSlug, weekRange.startDate),
        queryFn: async () => (await getPublicPartnerEventsStrict(partnerSlug, weekRange)).content,
        initialData: weekRange.startDate === initial.weekStart ? initial.events : undefined,
        placeholderData: keepPreviousData,
        enabled: Boolean(partnerSlug),
        staleTime: 60_000,
    })
}
